import { forwardRef, ReactNode } from 'react';

import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsPhone } from '@sravni/react-utils';

type TStepProps = {
  title: string;
  className?: string;
  children?: ReactNode;
};

export const Step = forwardRef<HTMLDivElement, TStepProps>(({ title, children, className }, ref) => {
  const isPhone = useIsPhone();

  return (
    <div ref={ref} className={className}>
      <Text size={16} strong>
        {title}
      </Text>
      <div className={isPhone ? 'h-mt-16' : 'h-mt-24'}>{children}</div>
    </div>
  );
});
